import { concatUrl } from "src/config/Configs";

export const updateURL = () => {
    return concatUrl(localStorage.getItem('back'));
}